import React from 'react'

import { ProductDisplay } from '@Domains/Product/Features/Display/Display'
import { PagePresentation } from '@Generated/graphql'

const ProductDisplayBlock = ({
  id,
  presentation = PagePresentation.Full,
}: {
  id?: string
  presentation?: PagePresentation
}) => (
  <ProductDisplay
    id={id}
    presentation={presentation}
  />
)

export default ProductDisplayBlock
